export default __webpack_public_path__ + "static/media/gs-2.5c65da68.png";